module.exports = __webpack_public_path__ + "assets/img/IntelligentSearch.850e2e5e.png";